/* eslint-disable semi */
import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);
let dictionary = new VueI18n({
  locale: 'en',
  messages: {
    en: {
      audit: 'Daily Audit',
      signIn: 'Sign In',
      aboutUs: 'About us',
      concerns: 'Concerns',
      reviews: 'Reviews',
      contactUs: 'Contact Us',
      'Dermatology (Skin)': 'Dermatology (Skin)',
      'Dentistry (Teeth)': 'Dentistry (Teeth)',
      'Psychiatry (Mental, Emotional or Behavioral Disorders)':
        'Psychiatry (Mental, Emotional or Behavioral Disorders)',
      'Pediatrics and New Born (Child)': 'Pediatrics and New Born (Child)',
      'Neurology (Brain & Nerves)': 'Neurology (Brain & Nerves)',
      'Orthopedics (Bones)': 'Orthopedics (Bones)',
      'Gynaecology and Infertility': 'Gynaecology and Infertility',
      'Ear, Nose and Throat': 'Ear, Nose and Throat',
      'Cardiology and Vascular Disease (Heart)':
        'Cardiology and Vascular Disease (Heart)',
      'Allergy and Immunology (Sensitivity and Immunity)':
        'Allergy and Immunology (Sensitivity and Immunity)',
      'Andrology and Male Infertility': 'Andrology and Male Infertility',
      Audiology: 'Audiology',
      'Cardiology and Thoracic Surgery (Heart & Chest)':
        'Cardiology and Thoracic Surgery (Heart & Chest)',
      'Chest and Respiratory': 'Chest and Respiratory',
      'Diabetes and Endocrinology': 'Diabetes and Endocrinology',
      'Diagnostic Radiology (Scan Centers)':
        'Diagnostic Radiology (Scan Centers)',
      'Dietitian and Nutrition': 'Dietitian and Nutrition',
      'Family Medicine': 'Family Medicine',
      'Gastroenterology and Endoscopy': 'Gastroenterology and Endoscopy',
      'General Practice': 'General Practice',
      'General Surgery': 'General Surgery',
      'Geriatrics (Old People Health)': 'Geriatrics (Old People Health)',
      Hematology: 'Hematology',
      'Hepatology (Liver Doctor)': 'Hepatology (Liver Doctor)',
      'Internal Medicine': 'Internal Medicine',
      'IVF and Infertility': 'IVF and Infertility',
      Laboratories: 'Laboratories',
      Nephrology: 'Nephrology',
      'Neurosurgery (Brain & Nerves Surgery)':
        'Neurosurgery (Brain & Nerves Surgery)',
      'Obesity and Laparoscopic Surgery': 'Obesity and Laparoscopic Surgery',
      'Oncology (Tumor)': 'Oncology (Tumor)',
      'Oncology Surgery (Tumor Surgery)': 'Oncology Surgery (Tumor Surgery)',
      'Ophthalmology (Eyes)': 'Ophthalmology (Eyes)',
      'Osteopathy (Osteopathic Medicine)': 'Osteopathy (Osteopathic Medicine)',
      'Pain Management': 'Pain Management',
      'Pediatric Surgery': 'Pediatric Surgery',
      'Phoniatrics (Speech)': 'Phoniatrics (Speech)',
      'Physiotherapy and Sport Injuries': 'Physiotherapy and Sport Injuries',
      'Plastic Surgery': 'Plastic Surgery',
      Rheumatology: 'Rheumatology',
      'Spinal Surgery': 'Spinal Surgery',
      'Urology (Urinary System)': 'Urology (Urinary System)',
      'Vascular Surgery (Arteries and Vein Surgery)':
        'Vascular Surgery (Arteries and Vein Surgery)',
      menu: 'Menu',
      clinic: 'Clinic',
      clinicProfile: 'Clinic Profile',
      last: 'Last',
      first: 'first',
      loading: 'Loading',
      patients: 'Patients',
      patient: 'Patient',
      search: 'Search',
      searchBy: 'Search By',
      actions: 'Actions',
      show: 'Show',
      log: 'Log',
      createNewReservation: 'Create New Reservation',
      newReservation: 'New Reservation',
      dateTime: 'Date & Time',
      reservationType: 'Reservation Type',
      reservationTypes: 'Reservation Types',
      chooseReservationType: 'Choose Reservation Type',
      examination: 'Examination',
      consulting: 'Consulting',
      save: 'Save',
      cancel: 'Cancel',
      id: 'Id',
      name: 'Name',
      mobile: 'Mobile',
      age: 'Age',
      first_reservation: 'First Reservation Date',
      logout: 'Logout',
      dashboard: 'Dashboard',
      doctors: 'Doctors',
      employees: 'Employees',
      allEmployees: 'All Employees',
      newEmployee: 'New Employee',
      reservations: 'Reservations',
      allReservations: 'All Reservations',
      items: 'Items',
      allItems: 'All Items',
      newItem: 'New Item',
      transactions: 'Transactions',
      allTransactions: 'All Transactions',
      newTransaction: 'New Transaction',
      next: 'Next',
      previous: 'Previous',
      patientName: 'Patient Name',
      patientMobile: 'Patient Mobile',
      patientAge: 'Patient Age',
      reservationTime: 'Reservation Time',
      patientInfo: 'Patient Info',
      phone: 'Phone',
      cellPhone: 'Cell Phone',
      dateOfBirth: 'Date Of Birth',
      weight: 'Weight',
      submit: 'Submit',
      amount: 'Amount',
      description: 'Description',
      paidAt: 'Paid At',
      category: 'Category',
      usagePrice: 'Usage Price',
      salary: 'Salary',
      specialization: 'Specialization',
      addTransaction: 'Add Transaction',
      reservationId: 'Reservation Id',
      reservationDate: 'Reservation Date',
      reservationInfo: 'Reservation Info',
      reservation: 'Reservation',
      price: 'Price',
      le: 'L.E',
      thereIsNoTransactionsYet: 'There is no transactions yet.',
      addPrescription: 'Add Prescription',
      prescription: 'Prescription',
      prescriptions: 'Prescriptions',
      addRequest: 'Add Request',
      medicine: 'Medicine',
      requests: 'Requests',
      history: 'History',
      medicalAnalysis: 'Medical Analysis',
      medicalRays: 'Medical Rays',
      reservationDay: 'Reservation Day',
      result: 'Result',
      title: 'Title',
      medicalAnalysisName: 'Medical Analyses Name',
      medicalAnalysisResult: 'Medical Analyses Result',
      medicalRaysName: 'Medical Rays Name',
      medicalRaysResult: 'Medical Rays Result',
      prescriptionOfDay: 'Prescription Of Reservation Day',
      employeeName: 'Employee Name',
      employeeEmail: 'Employee Email',
      employeeInfo: 'Employee Information',
      email: 'Email',
      gender: 'Gender',
      chooseGender: 'Choose Gender',
      chooseEmployeeGender: 'Choose Employee Gender',
      male: 'Male',
      female: 'Female',
      signUpInfo: 'Sign Up Information',
      passwordConfirmation: 'Password Confirmation',
      password: 'Password',
      nationalId: 'National Id',
      chooseMaritalStatus: 'Choose Marital Status',
      married: 'Married',
      maritalStatus: 'Marital Status',
      single: 'Single',
      jobInfo: 'Job Information',
      hireDate: 'Hire Date',
      jobTitle: 'Job Title',
      address: 'Address',
      personalInfo: 'Personal Information',
      contactInfo: 'Contact Information',
      employee: 'Employee',
      requestTitle: 'Title',
      payslips: 'Payslips',
      noPayslipsHaveBeenAddedYet: 'No Payslips Have Been Added Yet',
      addPayslip: 'Add Payslip',
      cantContinueWithAnyEmptyField: 'Can not Continue With Any Empty Field',
      bonusAmount: 'Bonus Amount',
      bonusDescription: 'Bonus Description',
      deductionDescription: 'Deduction Description',
      deductionAmount: 'Deduction Amount',
      basicSalary: 'Basic Salary',
      bonusesAndDeductions: 'Bonuses And Deductions',
      totalSumation: 'Total Sumation',
      totalSalaryAmount: 'Total Salary Amount',
      bonuses: 'Bonuses',
      deductions: 'Deductions',
      date: 'Date',
      noDeductionsForThisPayslip: 'No Deductions For This Payslip',
      addMedicalRays: 'Add Medical Rays',
      addMedicalAnalysis: 'Add Medical Analysis',
      noReservationsHaveBeenAddedYet: 'No Reservations Have Been Added Yet',
      noTransactionsHaveBeenAddedYet: 'No Transactions Have Been Added Yet',
      noPrescriptionHaveBeenMadeYet: 'No Prescription Have Been Made Yet',
      noRequestsHaveBeenRequestedYet: 'No Requests Have Been Requested Yet',
      noMedicalRaysHaveBeenAddedYet: 'No Medical Rays Have Been Added Yet',
      noMedicalAnalysisHaveBeenAddedYet:
        'No Medical Analysis Have Been Added Yet',
      transactionFor: 'Transaction For',
      transactionAmount: 'Transaction Amount',
      addMedicine: 'Add Medicine',
      discard: 'Discard',
      addNewEmployee: 'Add New Employee',
      addNewDoctor: 'Add New Doctor',
      doctor: 'Doctor',
      newDoctor: 'New Doctor',
      doctorName: 'Doctor Name',
      otherInfo: 'Other Information',
      issuedBy: 'Issued By',
      chooseImage: 'Choose Image',
      addNewReservation: 'Add New Reservation',
      calendar: 'Calendar',
      noResumeHasBeenAddedYet: 'No Resume Has Been Added Yet',
      uploadCV: 'Upload Resume',
      cv: 'Resume',
      download: 'Download',
      upload: 'Upload',
      files: 'Files',
      profile: 'Profile',
      accountSettings: 'Account Settings',
      clinicSettings: 'Clinic Settings',
      home: 'Home',
      updatePassword: 'Update Password',
      updateLanguage: 'Update Language',
      updateStyles: 'Update Styles',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      chooseLanguage: 'Choose Language',
      update: 'Update',
      pickColor: 'Pick Color',
      clickOnCircle: 'Click On Circle',
      status: 'Status',
      cancelled: 'Cancelled',
      pending: 'Pending',
      inProgress: 'In Progress',
      finished: 'Finished',
      cancelledAt: 'Cancelled At',
      cancellationReason: 'Cancellation Reason',
      cancellationFee: 'Cancellation Fee',
      reservationCancellation: 'Reservation Cancellation',
      notRequired: 'Not Required',
      thereIsNoArchivedEmployeeYet: 'There Is No Archived Employee Yet',
      thereIsNoArchivedDoctorYet: 'There Is No Archived Doctor Yet',
      current: 'Current',
      archived: 'Archived',
      all: 'All',
      heIsStillWorking: 'He Is Still Working',
      workStatus: 'Work Status',
      archive: 'Archive',
      restore: 'Restore',
      notifications: 'Notifications',
      showAllNotifications: 'Show All Notifications',
      minute: 'Minute',
      minutes: 'Minutes',
      hour: 'Hour',
      hours: 'Hours',
      day: 'Day',
      days: 'Days',
      week: 'Week',
      weeks: 'Weeks',
      month: 'Month',
      months: 'Months',
      year: 'Year',
      years: 'Years',
      thereAreNoNotificationsYet: 'There Are No Notifications Yet',
      addNewFile: 'Add New File',
      chooseDoctor: 'Choose Doctor',
      startTime: 'Start Time',
      endTime: 'End Time',
      filterBy: 'Filter By',
      youAreGoingToRestore: 'You are going to restore',
      youAreGoingToArchive: 'You are going to archive',
      'yes,Restore': 'Yes, restore',
      'yes,Archive': 'Yes, archive',
      restored: 'Restored',
      'yes,CancelIt': 'Yes, cancel it',
      youAreGoingToCancelThisReservation:
        'You are going to cancel this reservation',
      noDiagnoseHaveBeenAddedYet: 'No Diagnose Have Been Added Yet',
      addDiagnose: 'add Diagnose',
      diagnose: 'Diagnose',
      updateAuthentication: 'Update Authentication',
      updateEmail: 'Update E-mail',
      createUpdateRequest: 'Create Update Request',
      updateReason: 'Update Reason',
      updateApprovalRequest: 'Update Approval Request',
      thereIsNoChangeInThisField: 'There is no change in this field',
      action: 'Action',
      resourceType: 'Resource Type',
      finishedAt: 'Finished At',
      state: 'State',
      requestedAt: 'Requested At',
      approvalRequests: 'Approval Requests',
      updateReservation: 'Update Reservation',
      choosePatient: 'Choose Patient',
      start: 'Start',
      finish: 'Finish',
      startedAt: 'Started At',
      times: 'Times',
      addReservationType: 'Add Reservation Type',
      passed: 'Passed',
      reservationTypeName: 'Reservation Type Name',
      updateReservationType: 'Update Reservation Type',
      duration: 'Duration',
      criticalDiseases: 'Critical Diseases',
      language: 'Language',
      lastName: 'Last Name',
      firstName: 'First Name',
      middleName: 'Middle Name',
      referrer: 'Referrer'
    },
    ar: {
      audit: 'جــــــــــــرد يومـــــــــي',
      'Dermatology (Skin)': 'جلدية',
      'Dentistry (Teeth)': 'اسنان',
      'Psychiatry (Mental, Emotional or Behavioral Disorders)': 'نفسي',
      'Pediatrics and New Born (Child)': 'اطفال وحديثي الولادة',
      'Neurology (Brain & Nerves)': 'مخ واعصاب',
      'Orthopedics (Bones)': 'عظام',
      'Gynaecology and Infertility': 'نساء وتوليد',
      'Ear, Nose and Throat': 'انف واذن وحنجرة',
      'Cardiology and Vascular Disease (Heart)': 'قلب واوعية دموية',
      'Allergy and Immunology (Sensitivity and Immunity)': 'حساسية ومناعة',
      'Andrology and Male Infertility': 'ذكورة وعقم',
      Audiology: 'سمعيات',
      'Cardiology and Thoracic Surgery (Heart & Chest)': 'جراحة قلب وصدر',
      'Chest and Respiratory': 'صدر وجهاز تنفسي',
      'Diabetes and Endocrinology': 'سكر وغدد صماء',
      'Diagnostic Radiology (Scan Centers)': 'مراكز أشعة',
      'Dietitian and Nutrition': 'تخسيس وتغذية',
      'Family Medicine': 'طب الأسرة',
      'Gastroenterology and Endoscopy': 'جهاز هضمي ومناظير',
      'General Practice': 'ممارسة عامة',
      'General Surgery': 'جراحة عامة',
      'Geriatrics (Old People Health)': 'طب المسنين',
      Hematology: 'امراض دم',
      'Hepatology (Liver Doctor)': 'كبد',
      'Internal Medicine': 'باطنة',
      'IVF and Infertility': 'حقن مجهري واطفال انابيب',
      Laboratories: 'معامل تحاليل',
      Nephrology: 'كلى',
      'Neurosurgery (Brain & Nerves Surgery)': 'جراحة مخ واعصاب',
      'Obesity and Laparoscopic Surgery': 'جراحة سمنة ومناظير',
      'Oncology (Tumor)': 'اورام',
      'Oncology Surgery (Tumor Surgery)': 'جراحة أورام',
      'Ophthalmology (Eyes)': 'عيون',
      'Osteopathy (Osteopathic Medicine)': 'طب العظام',
      'Pain Management': 'علاج الآلام',
      'Pediatric Surgery': 'جراحة اطفال',
      'Phoniatrics (Speech)': 'نطق وتخاطب',
      'Physiotherapy and Sport Injuries': 'علاج طبيعي واصابات ملاعب',
      'Plastic Surgery': 'جراحة تجميل',
      Rheumatology: 'روماتيزم',
      'Spinal Surgery': 'جراحة عمود فقري',
      'Urology (Urinary System)': 'مسالك بولية',
      'Vascular Surgery (Arteries and Vein Surgery)': 'جراحة اوعية دموية',
      menu: 'القائمة',
      clinic: 'العيادة',
      clinicProfile: 'ملف العيادة',
      loading: 'تحميل',
      patients: 'المرضي',
      patient: 'المريض',
      search: 'بحث',
      searchBy: 'بحث ب',
      actions: 'الأوامر',
      show: 'عرض',
      log: 'الملف',
      createNewReservation: 'إنشاء حجز جديد',
      newReservation: 'حجز جديد',
      dateTime: 'التاريخ و الوقت',
      reservationType: 'نوع الحجز',
      reservationTypes: 'نأوع الحجز',
      chooseReservationType: 'اختار نوع الحجز',
      examination: 'كشف',
      consulting: 'إستشارة',
      save: 'حفظ',
      cancel: 'إلغاء',
      id: 'الكود',
      name: 'الأسم',
      mobile: 'الهاتف الخلوي',
      age: 'السن',
      first_reservation: 'تاريخ اول حجز',
      logout: 'تسجيل الخروج',
      dashboard: 'لوحة المعلومات',
      doctors: 'الأطباء',
      employees: 'الموظفيين',
      allEmployees: 'جميع الموظفيين',
      newEmployee: 'إنشاء موظف جديد',
      reservations: 'الحجوزات',
      allReservations: 'جميع الحجوزات',
      items: 'الأدوات',
      allItems: 'جميع الأدوات',
      newItem: 'إنشاء أداة جديدة',
      transactions: 'التحويلات المالية',
      allTransactions: 'جميع التحويلات',
      newTransaction: 'إنشاء تحويل جديد',
      next: 'التالي',
      previous: 'السابق',
      patientName: 'اسم المريض',
      patientMobile: 'هاتف المريض',
      patientAge: 'سن المريض',
      reservationTime: 'ميعاد الحجز',
      patientInfo: 'بيانات المريض',
      phone: 'التليفون المنزلي',
      cellPhone: 'التليفون الخلوي',
      dateOfBirth: 'تاريخ الميلاد',
      weight: 'الوزن',
      submit: 'حفظ',
      amount: 'المبلغ',
      description: 'الوصف',
      paidAt: 'دفعت في',
      usagePrice: 'سعر الأستخدام',
      category: 'الفئة',
      salary: 'المرتب الشهري',
      specialization: 'التخصص',
      addTransaction: 'إضافة دفع',
      reservationId: 'كود الحجز',
      reservationDate: 'تاريخ الحجز',
      reservationInfo: 'بيانات الحجز',
      reservation: 'حجز',
      price: 'السعر',
      le: 'ج.م',
      thereIsNoTransactionsYet: 'لا يوجد اي تحويلات مالية حتي الآن',
      addPrescription: 'إضافة روشيته',
      prescription: 'الروشيتة',
      addRequest: 'إضافة طلب',
      medicine: 'الدواء',
      requests: 'الطلبات',
      history: 'تاريخ',
      medicalAnalysis: 'التحاليل الطبية',
      medicalRays: 'الاشعة الطبية',
      reservationDay: 'حجز يوم',
      result: 'نتيجة',
      title: 'العنوان',
      medicalAnalysisName: 'اسم التحليل الطبي',
      medicalAnalysisResult: 'نتيجة التحليل',
      medicalRaysName: 'اسم الاشعة الطبية',
      medicalRaysResult: 'نتيجة الاشعة الطبية',
      prescriptionOfDay: 'الروشيتة الموافقة للحجز يوم',
      prescriptions: 'الروشتات',
      employeeName: 'أسم الموظف',
      employeeEmail: 'إيميل الموظف',
      employeeInfo: 'بيانات الموظف',
      email: 'البريد الألكتروني',
      gender: 'النوع',
      chooseGender: 'اختار النوع',
      chooseEmployeeGender: 'اختار نوع الموظف',
      male: 'ذكر',
      female: 'أنثي',
      signUpInfo: 'بيانات التسجيل',
      passwordConfirmation: 'تأكيد كلمة المرور',
      password: 'كلمة المرور',
      nationalId: 'الرقم القومي',
      chooseMaritalStatus: 'ختار الحالة الأجتماعية',
      married: 'متزوج',
      single: 'أعزب',
      jobInfo: 'بيانات الوظيفة',
      hireDate: 'تاريخ التوظيف',
      jobTitle: 'أسم الوظيفة',
      address: 'العنوان',
      personalInfo: 'البيانات الشخصية',
      maritalStatus: 'الحاة الأجتماعية',
      contactInfo: 'معلومات التواصل',
      employee: 'الموظف',
      requestTitle: 'أسم الطلب',
      payslips: 'كشوف حساب',
      noPayslipsHaveBeenAddedYet: 'لم يتم إضافة مدفوعات حتي الأن',
      addPayslip: 'إضافة قسيمة دفع',
      cantContinueWithAnyEmptyField: 'لا يمكن الاستمرار وهناك حقل فارغ',
      bonusDescription: 'وصف المكافأة',
      bonusAmount: 'مكافأة',
      deductionDescription: 'وصف الخصم',
      deductionAmount: 'كمية الخصم',
      basicSalary: 'المرتب الأساسي',
      bonusesAndDeductions: 'الزيادات و الخصومات',
      totalSumation: 'المجموع',
      totalSalaryAmount: 'المرتب النهائي',
      bonuses: 'الزيادة',
      deductions: 'الخصم',
      date: 'التاريخ',
      noDeductionsForThisPayslip: 'لا يوجد خصومات لهذه المرة',
      addMedicalRays: 'إضافة أشعة',
      addMedicalAnalysis: 'إضافة تحاليل',
      noTransactionsHaveBeenAddedYet: 'لم تيم أضافة تحويلات مالية حتيالأن',
      noPrescriptionHaveBeenMadeYet: 'لم يتم عمل اي روشيتة حتي الان',
      noRequestsHaveBeenRequestedYet: 'لا يوجد اي طلابات مطلوبة حتي الان',
      noMedicalRaysHaveBeenAddedYet: 'لم يتم إضافة اعة حتي الآن',
      noMedicalAnalysisHaveBeenAddedYet: 'لم يتم إضافة اي حاليل حتي الآن',
      transactionFor: 'تحويل نقدي ل',
      transactionAmount: 'المبلغ',
      addMedicine: 'إضافة دواء',
      discard: 'ألغاء',
      addNewEmployee: 'إضافة موظف جديد',
      addNewDoctor: 'إضافة دكتور جديد',
      doctor: 'دكتور',
      noReservationsHaveBeenAddedYet: 'لا يوجد حجوزات حتي الآن',
      newDoctor: 'دكتور جديد',
      doctorName: 'أسم الدكتور',
      otherInfo: 'معلومات اخري',
      issuedBy: 'عملت عن طريق',
      chooseImage: 'اختار صورة',
      addNewReservation: 'إضافة حجز جديد',
      calendar: 'التقويم',
      noResumeHasBeenAddedYet: 'لم يتم إضافة سيرة ذاتية حتي الآن',
      uploadCV: 'إضافة سيرة ذاتية',
      cv: 'السيرة الذاتية',
      download: 'تحميل',
      upload: 'رفع',
      files: 'الملفات',
      profile: 'الملف الشخصي',
      accountSettings: 'إعدادات الحساب الشخصي',
      clinicSettings: 'إعدادات العيادة',
      home: 'الرئيسية',
      updatePassword: 'تحديث كلمة المرور',
      updateLanguage: 'تحديث اللغة',
      updateStyles: 'تحديث الشكل',
      currentPassword: 'كلمة المرور الحالية',
      newPassword: 'كلمة المرور الجديد',
      chooseLanguage: 'اختار اللغة',
      update: 'تحديث',
      pickColor: 'اختار لون',
      clickOnCircle: 'قم بالضغط علي الدائرة',
      status: 'الحالة',
      cancelled: 'تم الغائها',
      pending: 'منتظرة',
      inProgress: 'في تقدم',
      finished: 'انتهت',
      cancelledAt: 'الغت في',
      cancellationReason: 'سبب الألغاء',
      cancellationFee: 'تكاليف الألغاء',
      reservationCancellation: 'الغاء الحجز',
      notRequired: 'غير مهمة',
      thereIsNoArchivedEmployeeYet: 'لا يوجد موظفين تم ارشفتهم حتي الآن',
      thereIsNoArchivedDoctorYet: 'لا يوجد دكاترةتم ارشفتهم حتي الآن',
      current: 'الحالي',
      archived: 'المؤرشف',
      all: 'الكل',
      heIsStillWorking: 'مازال في العمل',
      workStatus: 'حالة العمل',
      archive: 'أرشفة',
      restore: 'إعادة للعمل',
      notifications: 'إخطارات',
      showAllNotifications: 'عرض كل الاخطارات',
      minute: 'دقيقة',
      minutes: 'دقائق',
      hour: 'ساعة',
      hours: 'ساعات',
      day: 'يوم',
      days: 'ايام',
      week: 'اسبوع',
      weeks: 'اسابيع',
      month: 'شهر',
      months: 'شهور',
      year: 'سنة',
      years: 'سنوات',
      thereAreNoNotificationsYet: 'لا يوجد أخطارات',
      addNewFile: 'إضافة ملف جديد',
      chooseDoctor: 'أختار دكتور',
      startTime: 'بداية من',
      endTime: 'حتي الي',
      filterBy: 'بحث عن طيرق',
      youAreGoingToRestore: 'انت علي وشك  اعادة',
      youAreGoingToArchive: 'انت علي وشك آرشفة',
      'yes,Restore': 'نعم ',
      'yes,Archive': 'نعم',
      restored: 'تمت إعادته',
      'yes,CancelIt': 'نعم',
      youAreGoingToCancelThisReservation: 'انت علي وشك الغاء هذا الحجز',
      noDiagnoseHaveBeenAddedYet: 'لم يتم إضافة تشخيص حتي الآن',
      addDiagnose: 'إضافة تشخيص',
      last: 'الاخيرة',
      first: 'الاولي',
      diagnose: 'التشخيص',
      updateAuthentication: 'تعديل  عناصر المصادقة',
      updateEmail: 'نعديل البريد الألكتروني',
      createUpdateRequest: 'إنشاء طلب تعديل',
      updateReason: 'سبب التعديل',
      updateApprovalRequest: 'طلب موافقة التحديث',
      thereIsNoChangeInThisField: 'لا يوجد تعديل',
      action: 'الفعل',
      resourceType: 'نوع المادة',
      finishedAt: 'عملت في',
      state: 'الحالة',
      requestedAt: 'طلب في',
      approvalRequests: 'طلبات الموافقة',
      updateReservation: 'تعديل حجز',
      choosePatient: 'اختار مريض',
      start: 'ابدأ',
      finish: 'انتهي',
      startedAt: 'بدا في',
      times: 'الأوقات',
      addReservationType: 'إضافة نوع حجز',
      passed: 'انتهي وقتها',
      reservationTypeName: 'اسم نوع الحجز',
      updateReservationType: 'تعديل نوع الحجز',
      duration: 'المدة',
      criticalDiseases: 'الأمراض المزمنة',
      language: 'اللغة'
    }
  }
});

export default dictionary;



// WEBPACK FOOTER //
// ./src/i18n/dictionary.js